"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/popover/style/index.js
// module id = 223
// module chunks = 1